import type { ReactNode } from 'react';
import type { LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils/cn';

type Props = {
  children: ReactNode;
  /** Hex or CSS var. Defaults to teal. */
  color?: string;
  /** Dark glass variant (used over images). */
  glass?: boolean;
  icon?: LucideIcon;
  className?: string;
};

export function Badge({ children, color = 'var(--color-teal)', glass = false, icon: Icon, className }: Props) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded-md px-2 py-1 text-[11px] font-semibold uppercase tracking-[0.05em] text-white',
        className,
      )}
      style={
        glass
          ? { background: 'rgba(11,13,18,0.7)', backdropFilter: 'blur(6px)' }
          : { background: color }
      }
    >
      {Icon && <Icon size={10} strokeWidth={2.2} />}
      {children}
    </span>
  );
}
